<template>
  <div id="print_calender" class="table_section" style="display: none;">
    <div class="month_year" style="background: rgba(30, 67, 127);
        border-radius: 15px 15px 0px 0px;
        padding: 16px 12px 10px;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        width: 100%;
        box-sizing: border-box;">
      <div class="month_name" @click="getCalenderDays()" style="color: #fff;
        font-size: 24px;
        font-weight: 700;">
        Menu: {{ currentMonthName }} , {{ get_year }}
      </div>
      <p style="font-size: 16px;
        color: #fff;
        margin: 0px;
        font-weight: 300 !important;">
        <b style="float: right"> {{ site_name }} , {{ age_group }} </b>
      </p>
    </div>

    <table class="table" cellspacing="0" cellpadding="0" style="width: 100%;
        border: none;
        line-height: 1.2;">
      <thead style="background: #132d56;">
        <tr>

          <th style="width: 12%; color: #fff;
        vertical-align: bottom;
        padding: 5px;
        border-right: 2px solid #233b61;
        font-size: 12px;">Monday</th>
          <th style="width: 12%;color: #fff;
        vertical-align: bottom;
        padding: 5px;
        border-right: 2px solid #233b61;
        font-size: 12px;">Tuesday</th>
          <th style="width: 12%;color: #fff;
        vertical-align: bottom;
        padding: 5px;
        border-right: 2px solid #233b61;
        font-size: 12px;">Wednesday</th>
          <th style="width: 12%;color: #fff;
        vertical-align: bottom;
        padding: 5px;
        border-right: 2px solid #233b61;
        font-size: 12px;">Thursday</th>
          <th style="width: 12%;color: #fff;
        vertical-align: bottom;
        padding: 5px;
        border-right: 2px solid #233b61;
        font-size: 12px;">Friday</th>
          <th style="width: 12%;color: #fff;
        vertical-align: bottom;
        padding: 5px;
        border-right: 2px solid #233b61;
        font-size: 12px;">Saturday</th>
          <th style="width: 12%;color: #fff;
        vertical-align: bottom;
        padding: 5px;
        border-right: 2px solid #233b61;
        font-size: 12px;">Sunday</th>

        </tr>
      </thead>
      <tbody>
        <tr v-for="week in calenderdays?.weeks">
          <td v-for="days in week.days" style="vertical-align: top;">
            <p v-if="!isPastMonth(days)" class="pt-1 pb-1" style="float: left; margin-top: -10px;"><b>{{
              showDate(days.date) }}</b></p>
            <div v-if="verifyExcludeDay(days.date) === false && !isPastMonth(days)"
              v-for="options in getWeekDayOptions(week.menuCycle, days.day)?.options">
              <p><b>{{ options.name }}</b></p>
              <p v-for="option in sortedArray(options?.menu_cycle_day_option_components)">

                {{ option?.show_name }}
              </p>
            </div>
          </td>
        </tr>


      </tbody>
    </table>
   

     <div style="font-size: 12px; line-height: 18px; padding-top: 15px; width: 100%;">

  <table style="width: 100%; border-collapse: collapse;">
    <tbody>
      <tr>

        <!-- Left Column -->
        <td style="width: 38%; vertical-align: top; padding-right: 15px;font-size: 12px;">
           
            This institution is an equal opportunity provider.<br>
            Menu is subject to change.
           
        </td>

        <!-- Right Column -->
        <td style="width: 62%; vertical-align: top;">

          <table style="width: 100%; border-collapse: collapse;">
            <tbody>

              <tr>
                <th colspan="2" align="left" style="padding-bottom: 8px; font-size: 12px;">
                  Milk Options
                </th>
              </tr>

              <tr>
                <td style="font-size: 12px; line-height: 18px; padding-right: 10px; vertical-align: top;">
                  <div>
                    <b>NSLP:</b> Whole, 2%, 1%, or Fat-Free (flavored or unflavored)
                  </div>

                  <div style="padding-top: 10px;">
                    <b>SBP:</b> 1% or Fat-Free (flavored or unflavored)
                  </div>
                </td>

                <td style="font-size: 12px; line-height: 18px; padding-left: 10px; vertical-align: top;">
                  <ul style="margin: 0; list-style: none; padding: 0;">
                    <li>
                      <b>CACFP:</b> Ages 1-2 – Whole (unflavored)
                    </li>

                    <li style="padding-left: 45px;">
                      Ages 2-5 – 1% or Fat-Free (unflavored)
                    </li>

                    <li style="padding-left: 45px;">
                      Ages 6+ – 1% or Fat-Free (flavored or unflavored)
                    </li>
                  </ul>
                </td>
              </tr>

            </tbody>
          </table>

        </td>

      </tr>
    </tbody>
  </table>

</div>
 
  </div>
</template>
<script>
import $ from "jquery";
var moment = require('moment');

export default {
  props: [
    "calender_days",
    "currentMonthName",
    "get_year",
    "sites",
    "site",
    "age_grade_offering",
    "meal_type",
    "excludeDays",
    "isFirstDaySunday"
  ],

  components: {},

  data() {
    return {
      calenderdays: this.calender_days,
      site_name: '',
      age_group: '',
      moment: moment
    };
  },




  methods: {
    isPastMonth(cday) {
      return (cday.is_past_month && this.isFirstDaySunday && cday.type == 'next');
    },
    verifyExcludeDay(current_date) {
      // console.log('excludeDays');
      if (this.excludeDays) {
        var new_date = moment(current_date).format('MM/DD/YYYY');
        let obj = this.excludeDays.find(o => o.date === new_date);
        if (obj) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    sortedArray: function (r_arrays) {
      let recipe_arrays = [];
      
      if (!r_arrays || r_arrays.length == 0) {
        return recipe_arrays;
      }
      for (let index = 0; index < r_arrays.length; index++) {
        if (!r_arrays[index].is_exclude_from_printable_calendar && r_arrays[index].recipe && r_arrays[index].recipe.category != 'Milk') {
          recipe_arrays.push(r_arrays[index].recipe);
        }

      }
      // console.log("recipe_arrays", recipe_arrays);
      let a = _.orderBy(recipe_arrays, 'name', 'asc');
      a = _.orderBy(a, 'category_sort', 'asc');
      return a;
    },
    showDate(dates) {
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (isSafari) {
        // Safari requires the date string to be in YYYY/MM/DD format
        const parts = String(dates).split('-');
        dates = new Date(`${parts[0]}/${parts[1]}/${parts[2]}`);
      } else {
        dates = new Date(dates);
      }
      return dates.getDate();
    },
    getWeekDayOptions(menuCycle, day) {
      console.log("getWeekDayOptions in", menuCycle, day);

      if (menuCycle && menuCycle.menu_cycle_days.length > 0) {
        const options = menuCycle.menu_cycle_days.find(ele => ele.day_of_week === day);

        if (options) {
          console.log("getWeekDayOptions final option", options);
          return options;
        }
      }

      return '';
    },
    getCalenderDays() {
      console.log("age_grade_offering", this.age_grade_offering, this.site);
      let site = this.site;
      this.age_group = this.age_grade_offering;
      this.site_name = this.sites.find(ele => ele.id === site)?.name;

      this.calenderdays = this.calender_days;
      console.log("calender_days", this.calender_days, this.site_name);
    }
  },
};
</script>



<style scoped >
@media print {

* {
  -webkit-print-color-adjust: exact !important;
  /* Chrome, Safari, Edge */
  print-color-adjust: exact !important;
  /*Firefox*/
}

body {
  font-family: 'Lato', sans-serif !important;
  /* padding: 20px; */
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 0px;
  width: 100%;
}

.left_part {
  display: flex;
}


.month_year {
  background: rgba(30, 67, 127);
  border-radius: 15px 15px 0px 0px;
  padding: 16px 12px 10px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
}

.month_name {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
}

.month_year p {
  font-size: 16px;
  color: #fff;
  margin: 0px;
  font-weight: 300 !important;
}

table.table {
  width: 100%;
  border: none;
  line-height: 1.2;
}

table.table thead {
  background: #132d56;
}

table.table thead th {
  color: #fff;
  vertical-align: bottom;
  padding: 5px;
  border-right: 2px solid #233b61;
  font-size: 12px;
}

table.table thead th:last-child {
  border-right: none;
}

table.table tr.grey_bar td {
  background: #e8e8e8;
  border-right: 2px solid #d9d9d9;
  border-bottom-color: #d9d9d9;
  padding: 7px 5px 6px 10px;
  font-size: 14px;
  color: #454545;
  font-weight: 600;
  text-align: left;
}

table.table tr td {
  font-size: 11px;
  line-height: normal;
  color: #454545;
  text-align: center;
  padding: 20px 5px 10px;
  border-style: solid;
  border-color: #eeeeee;
  border-width: 2px 2px 2px 0px;
  border-bottom-color: #cecece;
  line-height: 1.1;
}

table.table tr td:first-child {
  border-left: 2px solid #eeeeee;
}

table.table tr td p {
  margin: 0px;
}

table.table tr td p+p {
  margin-top: 5px;
}

@page {
  size: auto;
  margin: 0;
}
}
</style>
